import { tokenAliasOrValue } from "./base";
import { DimensionTokenData } from "./dimension";
import { z } from "zod";
export const BlurType = z.enum(["Layer", "Background"]);
export const BlurValue = z.object({
    type: BlurType,
    radius: DimensionTokenData,
});
export const BlurTokenData = tokenAliasOrValue(BlurValue);
